import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

import Logo from "./Logo.js";
import MenuContainers from "./MenuContainers.js";
import MenuResources from "./MenuResources.js";
import MenuBags from "./MenuBags.js";
import MenuMisc from "./MenuMisc.js";

import "./header.css";

const headerNavClasses =
  " cursor-pointer border-containx-beige md:hover:border-y-4 md:hover:border-b-containx-tan hover:text-containx-tan hover:bg-containx-beige transition md:flex md:items-center p-2 px-4 md:p-4 w-full md:w-fit";

const Header = () => {
  const [dropdown, setDropdown] = useState(null);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // Close dropdowns and mobile menu if clicked outside
  useEffect(() => {
    const handleClickOutsideDropdown = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(null);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideDropdown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    };
  }, []);

  // Function to close dropdown on item click
  const closeDropdownMenu = () => {
    setDropdown(null);
    setMobileMenuOpen(false); // Optionally close the mobile menu as well
  };

  return (
    <>
      <header className="w-full z-10">
        <div className="flex justify-between bg-white border-b border-containx-beige text-containx-navy transition-all duration-500 h-20 md:h-fit">
          {Logo()}

          {/* Hamburger Menu for Mobile */}
          <div className="md:hidden flex items-center pr-8">
            <button
              onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
              className="focus:outline-none"
            >
              {isMobileMenuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
            </button>
          </div>

          {/* Navigation Menu */}

          <nav
            ref={mobileMenuRef} // Attach ref for mobile menu
            className={`${
              isMobileMenuOpen ? "block" : "hidden"
            } md:flex absolute md:relative w-full md:w-auto right-0 top-20 md:top-0 md:p-0 z-10 bg-white`}
          >
            <ul
              className="md:space-y-0 md:flex"
              onClick={() => setMobileMenuOpen(false)}
            >
              <li className="flex">
                <NavLink to="/about" className={headerNavClasses}>
                  About
                </NavLink>
              </li>

              {/* Bags with Dropdown */}
              <li className="flex">
                <span
                  className={headerNavClasses}
                  onClick={() => {
                    setDropdown(MenuBags(dropdownRef, closeDropdownMenu));
                  }}
                >
                  Bags
                </span>
              </li>

              {/* Containers with Dropdown */}
              <li className="flex">
                <span
                  className={headerNavClasses}
                  onClick={() =>
                    setDropdown(MenuContainers(dropdownRef, closeDropdownMenu))
                  }
                >
                  Containers
                </span>
              </li>

              {/* Misc with Dropdown */}
              <li className="flex">
                <span
                  className={headerNavClasses}
                  onClick={() =>
                    setDropdown(MenuMisc(dropdownRef, closeDropdownMenu))
                  }
                >
                  Misc
                </span>
              </li>

              {/* Resources Dropdown */}
              <li className="flex">
                <span
                  className={headerNavClasses}
                  ref={dropdownRef}
                  onClick={() =>
                    setDropdown(MenuResources(dropdownRef, closeDropdownMenu))
                  }
                >
                  Resources
                </span>
              </li>
              <li className="flex">
                <NavLink to="/contact" className={headerNavClasses}>
                  Contact
                </NavLink>
              </li>
            </ul>

            {isMobileMenuOpen && (
              <div
                className="fixed w-full h-full bg-black bg-opacity-40 hover:bg-opacity-30 transition-all"
                onClick={() => {
                  setMobileMenuOpen(false);
                  setDropdown(null);
                }}
              >
                {/* grayed out background behind the mobile menu */}
              </div>
            )}
          </nav>

          <div className="hidden md:block md:w-32">
            {/* Placeholder to keep nav centered. Can add search bar, cart, etc. */}
          </div>
        </div>

        {/* Dropdown area */}
        {dropdown && (
          <>
            <div className="fixed w-full h-full flex justify-center">
              <div className="fixed w-full h-full bg-black bg-opacity-40 hover:bg-opacity-30 transition-all z-0">
                {/* grayed out background behind the menu */}
              </div>
              <div className="w-full h-fit md:w-3/4 md:h-fit z-10 bg-white text-containx-navy shadow-md transition-all duration-200 ease-in-out">
                <div>{dropdown}</div>
              </div>
            </div>
          </>
        )}
      </header>
    </>
  );
};

export default Header;
